import { ITEMS_PER_PAGE, type QueryPagination } from 'components'
import { endpoints } from 'constants/endpoints'
import api from 'services/api'

import { toResponseClustersData } from './adapters'
import type {
  RequestClustersMaterialsData,
  ResponseClustersData,
  ResponseClustersDataApi,
  Technology,
  TrackingResponse,
} from './interfaces'

export * from './interfaces'

export const filterClustersMaterials = async (
  body: RequestClustersMaterialsData,
  pagination: QueryPagination,
): Promise<ResponseClustersData> => {
  const response = await api.post<ResponseClustersDataApi>(
    endpoints.backofficeClustersMaterials,
    body,
    {
      params: { ...pagination, perPage: ITEMS_PER_PAGE },
    },
  )

  return toResponseClustersData(response.data)
}

export const downloadClustersMaterials = async () => {
  const response = await api.get(endpoints.backofficeClustersDownloadExcel, {
    headers: {
      'Content-Disposition': 'attachment"',
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'blob',
  })

  return response.data
}

export const getTechnologies = async () => {
  const response = await api.get<Technology[]>(endpoints.backofficeClusters)

  return response.data
}

export const uploadClustersFile = async (
  file: FormData,
  setProgress?: (progress: number) => void,
) => {
  const response = await api.post(endpoints.backofficeClustersUpload, file, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress(progressEvent) {
      const percentCompleted = progressEvent.total
        ? Math.round((progressEvent.loaded * 100) / progressEvent.total)
        : 0
      if (setProgress) setProgress(percentCompleted)
    },
  })

  return response.data
}

export const getClusterTracking = async (pagination: QueryPagination) => {
  const response = await api.get<TrackingResponse>(endpoints.backofficeClustersTracking, {
    params: pagination,
  })

  return response.data
}
